module.exports = __webpack_public_path__ + "img/hinrundensieger.2e8d5df1.png";